import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import styled from "styled-components";
import { Button } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { THEME_MAP } from "../theme";
import dayjs from "dayjs";

// Re-use styling from TrialActivatedConfirmation or create new ones
const Container = styled.div`
    height: 100%;
    width: 100%;
    padding: 24px;
    overflow: auto;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ConfirmationContainer = styled.div`
    max-width: 600px; // Adjust width as needed
    width: 100%;
    background: ${THEME_MAP["color-basic-100"]};
    border-radius: 4px;
    border: 1px solid ${THEME_MAP["color-basic-400"]};
    padding: 32px 48px; // Adjust padding
    text-align: center;
    box-shadow: 0 2px 10px rgba(0,0,0,0.1); // Optional shadow
`;

const IconContainer = styled.div`
    margin-bottom: 20px;
    color: ${THEME_MAP["color-success-500"]}; // Success color
    svg {
        font-size: 4rem;
    }
`;

 const MessagesContainer = styled.div`
    margin-bottom: 30px;
    h2 {
        margin-bottom: 15px;
        font-size: 1.8rem; // Adjust size
    }
    p {
        color: ${THEME_MAP["color-basic-700"]};
        line-height: 1.6; // Adjust line height
        font-size: 1.1rem; // Adjust size
        margin-bottom: 10px;
    }
    strong {
        color: ${THEME_MAP["color-primary-500"]}; // Highlight color
    }
`;

const ButtonContainer = styled.div`
    margin-top: 20px;
`;

export const PromotionActivatedConfirmation = () => {
    const history = useHistory();
    const { barId, promotionId } = useParams(); // Get IDs from URL
    const location = useLocation(); // Get state passed during navigation

    // Extract data passed via state
    const promotionName = location.state?.promotionName;
    const promotionEndDate = location.state?.endDate;

    const [formattedEndDate, setFormattedEndDate] = useState("");

    useEffect(() => {
        if (promotionEndDate) {
            setFormattedEndDate(dayjs(promotionEndDate).format("MMMM D, YYYY [at] hh:mm A"));
        }
        // Optional: Fetch full promotion details using promotionId if needed
    }, [promotionEndDate, promotionId]);

    const goToPromotions = () => {
        if (barId) {
            history.push(`/promotions/${barId}`); // Navigate to bar's promotions list
        } else {
            history.push("/promotions"); // Fallback
        }
    };

     const createAnotherPromotion = () => {
        if (barId) {
             // Navigate back to the 'new' promotion screen for the same bar
             // Make sure the state is cleared appropriately when navigating back
             // Or potentially pass a flag to reset the form
            history.push("/promotion/new", { barId: barId }); // Pass barId if needed by the route/component
        } else {
            history.push("/promotion/new"); // Fallback
        }
    };


    return (
        <Container>
            <ConfirmationContainer>
                <IconContainer>
                    <CheckCircleOutlineIcon />
                </IconContainer>
                <MessagesContainer>
                    <h2>Promotion Activated!</h2>
                    {promotionName ? (
                        <p>
                            Your promotion &quot;<strong>{promotionName}</strong>&quot; is now active.
                        </p>
                    ) : (
                         <p>Your promotion is now active.</p>
                    )}
                    {formattedEndDate && (
                         <p>It will run until <strong>{formattedEndDate}</strong>.</p>
                    )}
                     <p>This activation used your bar&apos;s active free trial period.</p>
                </MessagesContainer>
                <ButtonContainer>
                    <Button
                        onClick={goToPromotions}
                        variant="contained"
                        color="primary"
                        style={{ marginRight: "16px" }} // Add some spacing
                    >
                        View All Promotions
                    </Button>
                     <Button
                        onClick={createAnotherPromotion}
                        variant="outlined"
                        color="primary"
                    >
                        Create Another Promotion
                    </Button>
                </ButtonContainer>
            </ConfirmationContainer>
        </Container>
    );
};

